import {useEffect} from 'react';
import {BackHandler} from 'react-native';

/**
 * Custom hook to handle hardware back button presses
 * @param handler - Function to handle back press. Return true to prevent default behavior, false to allow it
 */
export const useHardwareBack = (handler: () => boolean) => {
    useEffect(() => {
        const backHandler = BackHandler.addEventListener('hardwareBackPress', handler);
        return () => backHandler.remove();
    }, [handler]);
};